import React from 'react'
import PropTypes from 'prop-types'
import {get, take, takeRight, first} from 'lodash'
import className from 'classnames'
import axios from 'axios'
import Link from 'next/link'
import dynamic from 'next/dynamic'

import {t} from '@lib/helpers'

const DualSlide = dynamic(() => import('@components/DualSlide'))
const Meta = dynamic(() => import('@components/Meta'))

const About = ({}) => {
  return (
    <React.Fragment>
      <Meta title={`${t('pages.about.title')} – ${t('layout.title')}`} />

      <div className='About'>
        <DualSlide
          height='150vh'
          initValue={[0, -100]}
          conditions={({ratio, tlySet}) => {
            if (ratio <= 0) {
              tlySet([0, -100])
            } else if (ratio > 0 && ratio <= 0.25) {
              tlySet([-100, 0])
            }
          }}
        >
          <div
            className={className('DualSlide__wrapper', {
              'DualSlide__wrapper--h1': true,
              'DualSlide__wrapper--h1--blue': true,
            })}
          >
            <div className='DualSlide__wrapper__content'>
              <h2
                className='DualSlide__h2'
                dangerouslySetInnerHTML={{
                  __html: t('pages.about.dualslide.0.h2'),
                }}
              />

              <p className='DualSlide__p'>{t('pages.about.dualslide.0.p')}</p>

              <div className='Buttons'>
                <a
                  className='DualSlide__a'
                  href='#info'
                  onClick={(e) => {
                    e.preventDefault()

                    window.history.pushState(null, null, '#info')
                    document
                      .querySelector('#info')
                      .scrollIntoView({behavior: 'smooth'})
                  }}
                />
              </div>
            </div>
          </div>

          <div
            className={className('DualSlide__wrapper', {
              'DualSlide__wrapper--alt': true,
              'DualSlide__wrapper--blue': true,
            })}
          >
            <div className='DualSlide__wrapper__content'>
              <h2
                className='DualSlide__h2'
                dangerouslySetInnerHTML={{
                  __html: t('pages.about.dualslide.1.h2'),
                }}
              />

              <p className='DualSlide__p'>{t('pages.about.dualslide.1.p')}</p>
            </div>
          </div>

          <div className='DualSlide__image DualSlide__content--7'>
            <img
              className='DualSlide__image__img'
              alt='DualSlide__image__img'
              src='/images/DualSlide--7.jpg'
            />
          </div>

          <div className='DualSlide__image DualSlide__content--6'>
            <img
              className='DualSlide__image__img'
              alt='DualSlide__image__img'
              src='/images/DualSlide--6.jpg'
            />
          </div>
        </DualSlide>

        <div className='BodySpace'>
          <div className='Anchor' id='info'></div>
          <div className='container'>
            <p className='About__p'>{t('pages.about.p')}</p>

            <dl className='About__dl'>
              {[
                {
                  dt: t('pages.about.dl.0.dt'),
                  dd: t('pages.about.dl.0.dd'),
                  img: '/images/About__dl__item__img--0.svg',
                },
                {
                  dt: t('pages.about.dl.1.dt'),
                  dd: t('pages.about.dl.1.dd'),
                  img: '/images/About__dl__item__img--1.svg',
                },
                {
                  dt: t('pages.about.dl.2.dt'),
                  dd: t('pages.about.dl.2.dd'),
                  img: '/images/About__dl__item__img--2.svg',
                },
                {
                  dt: t('pages.about.dl.3.dt'),
                  dd: t('pages.about.dl.3.dd'),
                  img: '/images/About__dl__item__img--3.svg',
                },
                {
                  dt: t('pages.about.dl.4.dt'),
                  dd: t('pages.about.dl.4.dd'),
                  img: '/images/About__dl__item__img--4.svg',
                },
                {
                  dt: t('pages.about.dl.5.dt'),
                  dd: t('pages.about.dl.5.dd'),
                  img: '/images/About__dl__item__img--5.svg',
                },
              ].map((x, i) => (
                <div className='About__dl__item' key={i}>
                  <div className='About__dl__item__wrapper'>
                    <img
                      className='About__dl__item__img'
                      alt='About__dl__item__img'
                      src={get(x, 'img')}
                    />
                    <dt className='About__dl__item__dt'>{get(x, 'dt')}</dt>
                  </div>

                  <dd className='About__dl__item__dd'>{get(x, 'dd')}</dd>
                </div>
              ))}
            </dl>

            <div className='About__culture'>
              <img
                className='About__culture__img'
                alt='About__culture__img'
                src='/images/About__culture__img.jpg'
              />

              <div className='About__culture__right'>
                <div className='About__culture__right__top'>
                  <h3
                    className='About__culture__right__h3'
                    dangerouslySetInnerHTML={{
                      __html: t('pages.about.culture.h3'),
                    }}
                  />

                  <p className='About__culture__right__p'>
                    {t('pages.about.culture.p')}
                  </p>
                </div>

                <Link href='/careers'>
                  <a className='About__culture__right__a'>
                    <span className='About__culture__right__a__span'>
                      {t('pages.about.culture.a.span')}
                    </span>

                    <small className='About__culture__right__a__small'>
                      {t('pages.about.culture.a.small')}
                    </small>
                  </a>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

About.propTypes = {}

export default About
